import React,{useRef, useState, useEffect} from "react";
import {X, CircleNotch} from "@phosphor-icons/react";
import layerEvents from "../utils/layerEvents";
import vindrApi from "../utils/vindrapi";
import { Col, Row} from "react-bootstrap";
import EditableRange from "../components/EditableRange";

import {formatWindSpeed} from "../utils/functions";




class OverlayWind {

	max = 8;
	min = 6;
	windroses = [];
	defaultOpacity = .5;

	datasets = [
		{
			label:'100m',
			windQuery:'100',
			gradient:'linear-gradient(90deg,rgba(255, 255, 255, 1) 0%, rgba(99, 68, 137, 1) 25%, rgba(251, 251, 2, 1) 52%, rgba(255, 53, 0, 1) 77%, rgba(112, 36, 36, 1) 100%)',
			layer:{
				source : {
					id:'wind-raster',
					type: 'raster',
					'tiles': [ 
						'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
					],
					tileSize: 256
				},
				layer:{
					id: "wind-layer",
					type: "raster",
					source: "wind-raster",
					paint: {
						'raster-opacity' : this.defaultOpacity
					}
				},
			}
		},
		{
			label: '150m',
			windQuery:'150',
			gradient:'linear-gradient(90deg,rgba(255, 255, 204, 1) 0%, rgba(128, 0, 0, 1) 100%)',
			layer:{
				source : {
					id:'wind-raster',
					type: 'raster',
					'tiles': [ 
						'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
					],
					tileSize: 256
				},
				layer:{
					id: "wind-layer",
					type: "raster",
					source: "wind-raster",
					paint: {
						'raster-opacity' : this.defaultOpacity
					}
				},
			}
		},
		{
			label: '200m',
			windQuery:'200',
			gradient:'linear-gradient(90deg,rgba(255, 255, 204, 1) 0%, rgba(128, 0, 0, 1) 100%)',
			layer:{
				source : {
					id:'wind-raster',
					type: 'raster',
					'tiles': [ 
						'https://vindrtech.com/mapproxy/service?layer=wind_map_200m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
					],
					tileSize: 256
				},
				layer:{
					id: "wind-layer",
					type: "raster",
					source: "wind-raster",
					paint: {
						'raster-opacity' : this.defaultOpacity
					}
				},
			}
		}
	]


	constructor() {
		
		this.rose = React.createRef();
		this.gradient = React.createRef();
	}
	handleHeightChange(e){
		
		
		this.remLayer();
		
		this.activeLayer = this.datasets[e.target.value];
		
		this.addLayer();
		
		this.handleOpacityChange(this.opacity);
		
	}
	handleClick = (e) => {

		this.gradient.current.querySelector(".value").classList.add("loading");

		vindrApi.getWindSpeed(this.activeLayer.windQuery, e.lngLat.lat, e.lngLat.lng ).then((r)=>{
			
			
			this.gradient.current.querySelector(".value span").innerHTML = formatWindSpeed(r.windspeed);
			
			this.gradient.current.querySelector(".value").classList.remove("loading");
			
			const p = this.convertPadding(r.windspeed);
			this.gradient.current.querySelector(".value").style.left =p+'px';
			this.gradient.current.querySelector(".value").classList.toggle("right", p>180 ? true : false);
			this.gradient.current.querySelector(".value").classList.toggle("center", p>65 && p<=180 ? true : false);
		});
		
	}
	handleOpacityChange = (opc) => {
		this.opacity = opc;
		this.setLayerOpacity(this.activeLayer.layer.layer.id, opc);
	}
	setGetter = (e)=>{
		
		if(this.t)
			clearTimeout(this.t);
		this.t = null;
		
		this.t = setTimeout(()=>this.handleClick(e), 200);
	}
	addLayer(){
		
		if(!this.map.getSource(this.activeLayer.layer.source.id)){
			this.map.addSource(this.activeLayer.layer.source.id, this.activeLayer.layer.source);

			//set the opacity if there is a preset
			this.map.addLayer(this.activeLayer.layer.layer);
			

//			setTimeout(()=>{
//				this.gradient.current.style.background=this.activeLayer.gradient;
//				this.parent.forceUpdate();
//			},100);			
			this.map.on('click', this.handleClick);
			this.map.on('mousemove', this.setGetter);

			//this.map.moveLayer(this.activeLayer.layer.layer.id, 'project-geojson-fill');	
		
		}
	}
	remLayer(){
		
		if(!this.map.getSource(this.activeLayer.layer.source.id))
			return;
		

		if(this.map.getLayer(this.activeLayer.layer.layer.id))
			this.map.removeLayer(this.activeLayer.layer.layer.id);
		
		if(this.map.getSource(this.activeLayer.layer.source.id))
			this.map.removeSource(this.activeLayer.layer.source.id);
		
		this.map.off("click", this.handleClick);
		this.map.off("mousemove", this.setGetter);
		
	}
	convertPadding(value){
		
		var p = value-6;
		if(p<0)
			p=0;
		if(p>2)
			p=2;
		
		
		// 0->2 === 0->245px 
		p = (p*122.5);
		return p;
		
	}
	setLayerOpacity(l, opacity){
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = this.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				this.map.setPaintProperty(l, 'icon-opacity', opc);
				this.map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				this.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				var op = ['case',
					['boolean', ['feature-state', 'invisible'], false],0,
					opc
				];
				this.map.setPaintProperty(l, layer.type+'-opacity', op);
			}
		}
	}
	
	enterOverlay(){
		
		this.activeLayer = this.datasets[0];
		
		this.addLayer();
		

	}
	exitOverlay(){
		
		this.windroses = [];
		this.remLayer();
		clearTimeout(this.t);
		this.t = null;

	}
	handleClose(){
		
		if(this.parent && this.parent.exitMode)
			this.parent.exitMode();
	}

	panel(){
		
		if(this.windroses[this.parent.props.project.projectid])
			this.rose.current.src = this.windroses[this.parent.props.project.projectid];
		else {
			vindrApi.getWindRose(this.parent.props.project.projectid).then((r)=>{
				this.windroses[this.parent.props.project.projectid] = URL.createObjectURL(r);
				this.rose.current.src = this.windroses[this.parent.props.project.projectid];
			});
		}
		
		
		return (
			<div className="card overlayWind">
				<div className="row title">
					Wind map
					<span onClick={(e)=>{this.handleClose();}} className="btn btn-close btn-sm float-end"><X  size={12} /></span>
				</div>
				<Row className="height-selector">
					<Col xs="6">
						Height

					</Col>
					<Col xs="6" className="text-right">

						<select className="branded-select form-select" onChange={(e)=>{this.handleHeightChange(e)}}>
						{
							this.datasets.map((l, j)=>{
								return <option value={j}>{l.label}</option>
							})
						}
						</select>
					</Col>
				</Row>
				<div className="windrose text-center">
					<img ref={this.rose} src="/images/windrose.png" width="250" height="250" />
				</div>
				<div className="scale">
					
					
					
					<div ref={this.gradient} class="gradient">
						<div className="value">
							<span>0 m/s</span>
							<CircleNotch  size={16} />
						</div>
					</div>
					<div className="ticks">
					{
						[6, 6.5, 7, 7.5, 8].map((v)=>{return <div className="tick"><div>{v}</div></div>})
					}
					</div>
					
				</div>
				<Row>
					<Col xs="12 style-name pt-2">
						Layer opacity (%)
					</Col>
					<Col xs="12">
						<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={this.defaultOpacity*100} defaultValue={this.defaultOpacity*100} onChange={(e)=>{this.handleOpacityChange(e.target.value/100);}} />
					</Col>
				</Row>	
			</div>
		)
	}
}

export default OverlayWind;